import React, { lazy } from 'react'

import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

//	///////////////////////
//	MARK: IMPORTS
const Index = lazy(() => import('./Index'))
const IDIndex = lazy(() => import('./:id/Index'))

//	///////////////////////
//	MARK: EXPORTS
export const CrewTypeRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--human-resources--crew-type']}>
    <Route index element={<Index />} />
    <Route path=':id/*' element={<IDIndex />} />
  </SubRouter>
))
